import React, { Fragment } from "react";
import { Image } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { CAR_COLORS } from "../../../enums/OrderEnums";
import { edit_order_vendor_side } from "../../../store/actions/OrderingAction/vendorOrderingAction";
import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";

export const TableHeadOrdering = (props) => {
  return (
    <React.Fragment>
      <tr>
        <th style={{ width: "10%" }}>
          <p>
            Order <br />
            Type
          </p>
        </th>
        <th style={{ width: "25%" }}>
          <p>
            Name /<br /> Request No.
          </p>
        </th>
        <th style={{ width: "10%" }}>
          <p>
            No. <br />
            Items
          </p>
        </th>
        {/* <th style={{ width: "10%" }}>
          Amount /
          <br />
          Payment
        </th> */}
        <th style={{ width: "20%" }}>Order Reference</th>
        {/* <th style={{ width: "15%" }}> */}
        {/* <p>Req. Date /</p>
      <p>Time/</p> */}
        {/* <p>Timer</p> */}
        {/* </th> */}
        {/* <th style={{ width: "10%" }}>Total Wait time</th> */}
        <th style={{ width: "35%" }}>Actions</th>
      </tr>
    </React.Fragment>
  );
};

const TableBodyOrdering = (props) => {
  const dispatch = useDispatch();
  const calcItemsLength = () => {
    let count = 0;
    for (let i = 0; i < props.orderDetails?.order_items?.length; i++) {
      if (
        props.orderDetails?.order_items[i]?.isSubstituted ||
        props.orderDetails?.order_items[i]?.isCancelled
      ) {
      } else {
        count += 1;
      }
    }
    return count;
  };

  const onClickChangeStatusAlert = () => {
    Alert.error(
      `<h4>You can't perform this action because payment is not done</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
  };
  const onClickChangeStatus = (orderStatus, id, orderType) => {
    var formData = {};
    if (orderType === 3 && orderStatus === 4) {
      // check for dine in order
      formData = { order_status: orderStatus + 2, id: id };
    } else if (orderType === 0 && orderStatus === 4) {
      // check for dine in order
      formData = { order_status: orderStatus + 2, id: id };
    } else {
      formData = { order_status: orderStatus + 1, id: id };
    }
    if (orderStatus + 1 === 1) {
      formData.OrderAcceptTime = new Date().getTime();
    }
    if (orderType === 3 && orderStatus === 6) {
      if (orderStatus + 1 === 7) {
        formData.OrderCompleteTime = new Date().getTime();
      }
    } else {
      if (orderStatus + 1 === 7) {
        formData.OrderCompleteTime = new Date().getTime();
      }
    }
    if (orderStatus === 8) {
      formData = { order_status: 0, id: id };
      // formData.OrderAcceptTime = new Date().getTime();
    }

    // props.onUpdateOrderStatus(formData);
    const token = props?.auth?.user?.accessToken;
    dispatch(edit_order_vendor_side(token, formData, onSuccessChangeStatus));
  };

  const onSuccessChangeStatus = () => {
    Alert.success(`<h4>Request updated successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  return (
    <React.Fragment>
      <tbody className="w-100 super-admin-all-vendor-main-table-body seating-dashboard-body-new">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr
                  className={`sd_body_table-row ${
                    props?.orderDetails?.userConfirmed ? "td_b_g" : "td_b_o"
                  }`}
                  // style={{ textAlign: "center" }}
                  //   onClick={showTr}
                >
                  <td style={{ width: "10%" }}>
                    <img
                      src={
                        props?.orderDetails &&
                        props?.orderDetails?.order_type === 0
                          ? require("../../../assets/images/superadmin/ordericon/takeaway.svg")
                          : props?.orderDetails &&
                            props?.orderDetails?.order_type === 1
                          ? require("../../../assets/images/superadmin/ordericon/curb side.svg")
                          : props?.orderDetails &&
                            props?.orderDetails?.order_type === 3
                          ? require("../../../assets/images/superadmin/ordericon/dine in.svg")
                          : props?.orderDetails &&
                            props?.orderDetails?.order_type === 2
                          ? require("../../../assets/images/superadmin/ordericon/skip the line.svg")
                          : ""
                      }
                      alt={
                        props?.orderDetails &&
                        props?.orderDetails?.order_type === 0
                          ? "takeaway"
                          : props?.orderDetails &&
                            props?.orderDetails?.order_type === 1
                          ? "curb side"
                          : props?.orderDetails &&
                            props?.orderDetails?.order_type === 3
                          ? "dine in"
                          : ""
                      }
                      title={
                        props?.orderDetails &&
                        props?.orderDetails?.order_type === 0
                          ? "takeaway"
                          : props?.orderDetails &&
                            props?.orderDetails?.order_type === 1
                          ? "curb side"
                          : props?.orderDetails &&
                            props?.orderDetails?.order_type === 3
                          ? "dine in"
                          : ""
                      }
                      width="35px"
                    />
                  </td>
                  <td style={{ width: "25%" }}>
                    <p className="f12-500">
                      {props?.orderDetails &&
                      props?.orderDetails?.user_details &&
                      props?.orderDetails?.user_details?.first_name &&
                      props?.orderDetails?.user_details?.last_name
                        ? props?.orderDetails?.user_details?.first_name +
                          " " +
                          props?.orderDetails?.user_details?.last_name
                        : ""}
                    </p>
                    <p className="f10-400">
                      #{props?.orderDetails && props?.orderDetails?.order_id}
                    </p>
                    {/* {props?.orderDetails &&
                    props?.orderDetails?.order_type === 3 ? (
                      <NavLink
                        to="/reservationdashboard"
                        className="f9-400"
                        style={{ color: "#2196F3" }}
                      >
                        #{props?.orderDetails?.cross_ref_id?.diner_id}
                      </NavLink>
                    ) : (
                      ""
                    )} */}
                  </td>
                  <td style={{ width: "10%" }}>
                    <p className="f12-500">
                      {calcItemsLength(props?.orderDetails)}
                    </p>
                  </td>

                  <td style={{ width: "20%" }}>
                    <p className="f12-500">
                      {props?.orderDetails &&
                      props?.orderDetails?.order_type === 1 ? (
                        <Fragment>
                          <div>
                            {/* {console.log(props?.orderDetails)} */}
                            <p className="f12-500 mb-2">
                              {props?.orderDetails &&
                                props?.orderDetails?.curb_side_details?.number}
                            </p>
                            <p className="f9-500 opacity5">
                              {props?.orderDetails &&
                                props?.orderDetails?.curb_side_details &&
                                props?.orderDetails?.curb_side_details?.model}
                              {" | "}
                              {props?.orderDetails &&
                                props?.orderDetails?.curb_side_details &&
                                props?.orderDetails?.curb_side_details?.make}
                              {" | "}
                              {props?.orderDetails &&
                                props?.orderDetails?.curb_side_details &&
                                props?.orderDetails?.curb_side_details
                                  .vehical_type_value}
                              {" | "}
                              {props?.orderDetails &&
                                props?.orderDetails?.curb_side_details &&
                                props?.orderDetails?.curb_side_details
                                  .vehical_type}
                              {" | "}
                              {props?.orderDetails &&
                                props?.orderDetails?.curb_side_details &&
                                props?.orderDetails?.curb_side_details?.year}
                              {" | "}
                              {CAR_COLORS &&
                                CAR_COLORS.map((data, index) => {
                                  return data.value ===
                                    props?.orderDetails?.curb_side_details
                                      ?.color
                                    ? data.name
                                    : "";
                                })}
                            </p>
                            {/* <div
                              className="mt-1"
                              style={{
                                width: "15px",
                                height: "15px",
                                borderRadius: "50%",
                                backgroundColor: `${props?.orderDetails &&
                                  props?.orderDetails?.curb_side_details &&
                                  props?.orderDetails?.curb_side_details?.color
                                  }`,
                                boxShadow: "0px 4px 8px #00000029",
                              }}
                            ></div> */}
                          </div>
                        </Fragment>
                      ) : (
                        <Fragment>
                          {(props?.orderDetails &&
                            props?.orderDetails?.order_type === 3) ||
                          (props?.orderDetails &&
                            props?.orderDetails?.order_type === 2)
                            ? props?.orderDetails?.dine_in_details?.table_number
                            : "N/A"}
                        </Fragment>
                      )}
                    </p>
                  </td>
                  {/* <td
                    style={{ width: "10%" }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                      viewType(3);
                      viewOrderInDetail();
                    }}
                  >
                    <img
                      src={require("../../../assets/images/superadmin/ordericon/location.svg")}
                      width="35px"
                    />
                  </td> */}
                  {/* <td style={{ width: "14%" }}> */}

                  <td
                    style={{ width: "35%" }}
                    className="seating-dashboard-body-new"
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    <div className="action-section-body align-items-center">
                      <div className="middle-timer">
                        {/* <p className="font_12_r">Total Wait time</p> */}
                        {/* <div className="count-down-timer d-flex">
                            <i
                              className="fa fa-hourglass-half mr-3"
                              aria-hidden="true"
                            ></i>

                            <p className="font_16_m">
                              {seated_time_difference(minutesSeated)}
                            </p>
                            
                          </div> */}
                        <div className="f12-700 d-flex justify-content-center mt-2 p-2">
                          {/* <p className="f12-400">Status:&nbsp;</p> */}
                          {props?.orderDetails &&
                          props?.orderDetails?.order_status === 0 ? (
                            "Pending"
                          ) : props?.orderDetails?.order_status === 1 ? (
                            "Confirmed"
                          ) : props?.orderDetails?.order_status === 2 ? (
                            "Getting Prep"
                          ) : props?.orderDetails?.order_status === 3 &&
                            props?.orderDetails &&
                            props?.orderDetails?.order_type === 3 ? (
                            "Food Plating"
                          ) : props?.orderDetails?.order_status === 3 ? (
                            "Packing"
                          ) : props?.orderDetails?.order_status === 4 &&
                            props?.orderDetails &&
                            props?.orderDetails?.order_type === 3 ? (
                            <>
                              Ready for
                              <br /> Dine-in
                            </>
                          ) : props?.orderDetails?.order_status === 4 &&
                            props?.orderDetails &&
                            props?.orderDetails?.order_type === 0 ? (
                            <>
                              Ready for
                              <br /> Take Away
                            </>
                          ) : props?.orderDetails?.order_status === 4 &&
                            props?.orderDetails &&
                            props?.orderDetails?.order_type === 7 ? (
                            <>
                              Ready for
                              <br /> Delivery
                            </>
                          ) : props?.orderDetails?.order_status === 4 ? (
                            <>
                              Ready To
                              <br /> Pick
                            </>
                          ) : props?.orderDetails?.order_status === 5 &&
                            props?.orderDetails?.order_type === 7 ? (
                            "Out for Delivery"
                          ) : props?.orderDetails?.order_status === 5 ? (
                            "On The Way"
                          ) : props?.orderDetails?.order_status === 6 &&
                            props?.orderDetails &&
                            props?.orderDetails?.order_type === 3 ? (
                            "Served"
                          ) : props?.orderDetails?.order_status === 6 ? (
                            "Delivered"
                          ) : props?.orderDetails?.order_status === 7 ? (
                            "Complete"
                          ) : props?.orderDetails?.order_status === 8 ? (
                            "Cancelled"
                          ) : null}
                        </div>
                      </div>
                      <div>
                        {/* // hide button for ccomplete and cancelled */}
                        {(props?.orderDetails &&
                          props?.orderDetails?.order_status === 7) ||
                        (props?.orderDetails &&
                          props?.orderDetails?.order_status === 8) ? (
                          <> </>
                        ) : (
                          <>
                            <div
                              // className="n_button_d_status font_18_m popup-save-button"
                              // type="button"
                              align="center"
                              onClick={() =>
                                props?.orderDetails?.order_status === 4 &&
                                props?.orderDetails?.payment_status !== 1
                                  ? onClickChangeStatusAlert()
                                  : onClickChangeStatus(
                                      props?.orderDetails &&
                                        props?.orderDetails?.order_status,
                                      props?.orderDetails &&
                                        props?.orderDetails?._id,
                                      props?.orderDetails &&
                                        props?.orderDetails?.order_type
                                    )
                              }
                            >
                              {props?.orderDetails &&
                              props?.orderDetails?.order_status !== 6 ? (
                                <Image
                                  src={require("../../../assets/images/iconButton/right_arrow_green.svg")}
                                  alt="Delete"
                                  title="Delete Icon"
                                  // onClick={this.onOpenModal}
                                  fluid
                                  width="40"
                                />
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 6 ? (
                                <Image
                                  src={require("../../../assets/images/iconButton/Check_green.svg")}
                                  alt="Delete"
                                  title="Delete Icon"
                                  // onClick={this.onOpenModal}
                                  fluid
                                  width="40"
                                />
                              ) : null}
                            </div>
                            <div className="f10-500">
                              {props?.orderDetails &&
                              props?.orderDetails?.order_status === 0 ? (
                                "Accept"
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 1 ? (
                                <>
                                  Getting <br />
                                  Prep
                                </>
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 2 &&
                                props?.orderDetails &&
                                props?.orderDetails?.order_type === 3 ? (
                                "Food Plating"
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 2 ? (
                                "Packing"
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 3 &&
                                props?.orderDetails &&
                                props?.orderDetails?.order_type === 1 ? (
                                <>
                                  Ready for
                                  <br /> Curb Side
                                </>
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 3 &&
                                props?.orderDetails &&
                                props?.orderDetails?.order_type === 0 ? (
                                <>
                                  Ready for
                                  <br /> Take Away
                                </>
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 3 &&
                                props?.orderDetails &&
                                props?.orderDetails?.order_type === 2 ? (
                                <>
                                  Ready for
                                  <br /> Skip the line
                                </>
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 3 &&
                                props?.orderDetails &&
                                props?.orderDetails?.order_type === 3 ? (
                                <>
                                  Ready for
                                  <br /> Dine-in
                                </>
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 4 &&
                                props?.orderDetails &&
                                props?.orderDetails?.order_type === 3 ? (
                                "Served"
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 4 &&
                                props?.orderDetails &&
                                props?.orderDetails?.order_type === 0 ? (
                                "Delivered"
                              ) : props.orderDetails?.order_status === 4 &&
                                props.orderDetails?.order_type === 7 ? (
                                "Out for Delivery"
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 4 ? (
                                "On the way"
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 5 ? (
                                "Delivered"
                              ) : props?.orderDetails &&
                                props?.orderDetails?.order_status === 6 ? (
                                "Complete"
                              ) : null}
                            </div>
                          </>
                        )}
                      </div>
                      {/* {(props?.orderDetails &&
                        props?.orderDetails?.order_status === 7) ||
                      (props?.orderDetails &&
                        props?.orderDetails?.order_status === 8) ||
                      (props?.orderDetails &&
                        props?.orderDetails?.order_status === 0) ? (
                        <Fragment></Fragment>
                      ) : (
                        <div align="center" style={{ paddingLeft: "5px" }}>
                          <div
                            onClick={() =>
                              onChangeHold(
                                props?.orderDetails && props?.orderDetails?.onhold,
                                props?.orderDetails && props?.orderDetails?._id
                              )
                            }
                            style={{
                              borderRadius: "50%",
                              width: "25px",
                              border: "1px solid #FCB62B",
                              padding: "5px",
                            }}
                          >
                            <i
                              style={{ color: "#FCB62B", width: "100%" }}
                              className="fa fa-pause"
                              className={`${
                                props?.orderDetails && props?.orderDetails?.onhold
                                  ? "fa fa-play"
                                  : "fa fa-pause"
                              }`}
                            ></i>
                          </div>
                          {props?.orderDetails &&
                          props?.orderDetails?.order_type !== 8 ? (
                            <>
                              {props?.orderDetails && props?.orderDetails?.onhold
                                ? "Resume"
                                : "Put on hold"}
                            </>
                          ) : (
                            <> </>
                          )}
                        </div>
                      )} */}
                    </div>

                    {/* <div
                      className="container-fluid main-orders-table-action"
                      align="center"
                    >
                      <p>Total wait time</p>
                      <div className="row">
                        <div className="col-3">
                          <button className="btn add_button_custom_1 ">
                            Reject
                          </button>
                        </div>
                        <div className="col-6">
                          <div
                            className="btn btn-secondary w-100"
                            style={{
                              fontSize: ".75rem",
                              background: "#F0F0F0 0% 0% no-repeat padding-box",
                              borderRadius: "6px",
                              color: "#000000",
                            }}
                          >
                            <img
                              src={require("../../../assets/images/superadmin/ordericon/hourglass.svg")}
                              width="15px"
                            />
                            00 hh : 20 mins
                          </div>
                        </div>
                        <div className="col-3">
                          <button className="btn add_button_custom_success">
                            Accept
                          </button>
                        </div>
                      </div>
                    </div> */}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};

TableBodyOrdering.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  // servicesEnabled:
  //   state.onboarding.onboard_subscription_details.casual_dining_status &&
  //   state.onboarding.onboard_subscription_details.casual_dining_status.ordering,
  servicesEnabled:
    state.onboarding &&
    state.onboarding.onboard_subscription_details &&
    state.onboarding.onboard_subscription_details.fast_food_dining
      ? state.onboarding.onboard_subscription_details
          ?.fast_food_dining_status &&
        state.onboarding.onboard_subscription_details?.fast_food_dining_status
          ?.ordering
      : state.onboarding.onboard_subscription_details?.casual_dining_status &&
        state.onboarding.onboard_subscription_details?.casual_dining_status
          ?.ordering,
  allOrderDataa: state.vendorOrdering?.vendor_get_all_takeaway_order,
  onboarding: state.onboarding?.restaurantDetails,
});

export default connect(mapStateToProps, {
  edit_order_vendor_side,
})(withRouter(TableBodyOrdering));
